<div class="container-box">
  <app-table-header
    tableTitle="Gestione aziende"
    (btnUpdateClick)="loadCompany()"
  ></app-table-header>
  <div>
    <ng2-smart-table
      id="usersTable"
      class="table-content"
      [settings]="settings"
      [source]="sourceUsersTable"
    ></ng2-smart-table>
  </div>
</div>
